<template>
  <TestReport />
</template>

<script>
import TestReport from '@/components/content/education/courses/progress/CourseTestReport.vue'

export default {
  name: 'CourseBookTestReport',
  components: { TestReport }
}
</script>

<style scoped>

</style>
